import { mapFilters, overrideInitialFilters } from "../Overheads/stateUpdaters";
import { getSharedFilters } from "../Shared/sharedFilters";
import { fetchKeyFigures } from "./data/dataFetching";
import { extractRequestBodyFromFilters, updateFilters } from "./data/keyFiguresFilters";

export async function updateKeyFiguresPageState(companyAccess, languageKey, filters, setFilters, setData, translate) {
  const isInitialLoad = filters.isInitialLoad;
  const response = await fetchKeyFigures(
    languageKey,
    extractRequestBodyFromFilters(filters, filters.isInitialLoad),
    (error) => console.error(error),
    companyAccess
  );
  const payload = response?.data?.reportData ? response.data : response?.data?.data;
  if (!payload?.context || !Array.isArray(payload?.reportData?.businessKeyFigures)) {
    throw new Error("Invalid business-key-figures response");
  }

  const context = response?.data?.context;
  let submitedFilters = context.filters;
  let nextAvailableFilters = getSharedFilters(translate);
  const updatedFilters = await updateFilters(
    filters,
    submitedFilters || {},
    nextAvailableFilters || {},
    filters.isInitialLoad,
    companyAccess,
    languageKey,
    translate
  );
  setFilters(updatedFilters);
  setData(payload);
}
